const menu = [
  {
    id: 1,
    title: 'Яєчня з тостами та беконом',
    category: 'сніданок',
    price: 15.99,
    img: 'https://e-przepisykulinarne.pl/wp-content/uploads/2012/04/tost_boczek_jajko-1200x900.jpg',
    desc: `Золотиста яєчня у поєднанні з хрустким беконом та тостами - смачна та поживна.`,
  },
  {
    id: 2,
    title: 'Бургер з картоплею фрі',
    category: 'обід',
    price: 13.99,
    img: 'https://www.przyslijprzepis.pl/media/cache/big/uploads/media/recipe/0005/88/7090c2bfb5438fca6c393a263224b7988dcb1be7.jpeg',
    desc: `Свинячі відбивні, хрусткі овочі та сир, а також золотиста картопля фрі - чудове поєднання.`,
  },
  {
    id: 4,
    title: 'Шоколадний коктейль',
    category: 'коктейлі',
    price: 15.99,
    img: 'https://www.bestblender.pl/wp-content/uploads/2014/03/chocolatemilkshakemainjpg.jpg',
    desc: `Шоколадний коктейль зі збитими вершками та шматочками печива.`,
  },
  {
    id: 5,
    title: 'Американські млинці',
    category: 'сніданок',
    price: 17.99,
    img: 'https://maslove.pl/wp-content/uploads/2022/06/nalesniki-po-amerykansku-z-syropem-klonowym.jpg',
    desc: `Американські млинці з кленовим сиропом та фруктами`,
  },
  {
    id: 6,
    title: 'Спагеті карбонара',
    category: 'обід',
    price: 18.99,
    img: 'https://www.allrecipes.com/thmb/0USVgLLUxe68kwcVRTe7ZVbWq6M=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/11973-spaghetti-carbonara-II-mfs-044-6fb2128979334fe98c28064e75aa47c9.jpg',
    desc: `Спагеті карбонара - класична італійська страва, яка складається з локшини спагеті.`,
  },
  {
    id: 7,
    title: 'Стейк на грилі',
    category: 'вечеря',
    price: 18.99,
    img: 'https://podravkaiovariations.azureedge.net/8d1ede48-640e-11eb-b3f1-0242ac120021/v/f2b1f6a6-64bc-11eb-b6c2-0242ac130010/1024x768-f2b21802-64bc-11eb-a115-0242ac130010.jpeg',
    desc: `Стейк на грилі з картоплею та овочами`,
  },
  {
    id: 8,
    title: 'Полуничний коктейль',
    category: 'коктейлі',
    price: 12.99,
    img: 'https://static.gotujmy.pl/ZDJECIE_PRZEPISU_ETAP/shake-truskawkowy-358511.jpg',
    desc: `Полуничний коктейль з ванільним морозивом і крихтою`,
  },
  {
    id: 9,
    title: 'Бельгійські вафлі',
    category: 'сніданок',
    price: 13.99,
    img: 'https://f.wszelkieprzepisy.pl/images/4hf9bocr/gofry-belgijskie-orig.png',
    desc: `Бельгійські вафлі з фруктами та збитими вершками`,
  },
  {
    id: 10,
    title: 'Курка з рисом',
    category: 'обід',
    price: 24.99,
    img: 'https://static.fajnegotowanie.pl/media/uploads/media_image/auto/recipe-content/1451/mobile/kurczak-tikka-masala.jpg',
    desc: `Куряча тікка масала з рисом басматі.`,
  },
  {
    id: 11,
    title: 'Курка з картоплею',
    category: 'вечеря',
    price: 16.99,
    img: 'https://www.mniammniam.com/obrazki/kurczakpieczonyhcc7.jpg',
    desc: `Курка в медово-гірчичному соусі зі смаженою картоплею та морквою`,
  },
  {
    id: 12,
    title: 'Чорничний коктейль',
    category: 'коктейлі',
    price: 16.99,
    img: './images/menuSzejk1.png',
    desc: `Чорничний коктейль з соєвим молоком та чорничним мусом.`,
  },
  {
    id: 13,
    title: 'Круасани з яйцем',
    category: 'сніданок',
    price: 8.99,
    img: 'http://2.bp.blogspot.com/-NB6nlS4ew8s/VL1KvgjfjOI/AAAAAAAAD20/nqe7jUCfE1A/s1600/IS_DSC_3016%2Bna%2Bbloga.jpg',
    desc: `Круасани з яйцем, шинкою та сиром - смачний та поживний вибір.`,
  },
  {
    id: 14,
    title: 'Філе з картоплею',
    category: 'обід',
    price: 21.99,
    img: 'https://media.centrumrespo.pl/wp-content/uploads/2018/10/18002231/kurczakbok.png',
    desc: `Тальятелле з креветками та спаржею - італійська страва з поєднанням креветок і ніжної спаржі.`,
  },
  {
    id: 15,
    title: 'Філе на грилі',
    category: 'вечеря',
    price: 13.99,
    img: 'https://static.gotujmy.pl/ZDJECIE_PRZEPISU_ETAP/grillowane-piersi-z-kurczaka-306228.jpg',
    desc: `Філе курячої грудки на грилі з овочами в духовці
    `,
  },
  {
    id: 16,
    title: 'Банановий коктейль',
    category: 'коктейлі',
    price: 16.99,
    img: 'https://malacukierenka.pl/wp-content/uploads/2011/05/shake-orzechowy-z-bananami.jpg',
    desc: `Банановий коктейль з кокосовим молоком та арахісовим маслом`,
  },
];
export default menu;
